var s = /* @__PURE__ */ ((r) => (r.primary = "primary", r.secondary = "secondary", r.transparent = "transparent", r))(s || {}), p = /* @__PURE__ */ ((r) => (r.sm = "sm", r.md = "md", r.lg = "lg", r.xl = "xl", r))(p || {});
export {
  p as TextareaSizeEnum,
  s as TextareaThemeEnum
};
